// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__zyfVm","title":"styles_title__3xDed"};